(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interested-in-treatments"] && !Shopify.designMode) return;
  try {
    
  let mob_select = document.querySelector('.mob_tab_select');
  if(mob_select){
    mob_select.addEventListener("change", function(e){
      console.log(mob_select.value);
    }); 
  }

  } catch(e) { console.error(e); }
})();
})();
